import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Button } from "antd";

export default function CTAFooterSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      className="py-10 md:py-20 bg-gradient-to-br from-[#EAFCEF] to-[#80E280]/10 w-full"
      ref={ref}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 md:mb-8">
            Join Our Journey
          </h2>
          <p className="text-lg text-gray-600 mb-6 md:mb-12 max-w-2xl mx-auto">
            Whether you're looking to partner with us or join our mission, we'd
            love to hear from you.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-6 justify-center w-full">
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button
                onClick={() => {}}
                className="bg-[#80E280] hover:bg-[#70D270] text-white px-8 py-4 text-lg transition-all duration-300 w-full"
              >
                Partner With Us →
              </Button>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <Button
                onClick={() => {}}
                className="px-8 py-4 text-lg transition-all duration-300 w-full"
              >
                Careers at OneGrad →
              </Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
